import { gql } from '@apollo/client';

export const USER_ADDITIONAL_DATA_UPDATED = gql`
  subscription userAdditionalDataUpdated {
    userAdditionalDataUpdated {
      userId
      avatar
    }
  }
`;
